const stickyHeader = () => {
  window.addEventListener(`load`, () => {
    const headerElement = document.querySelector(`.header`);
    const mainElement = document.querySelector(`.main`);
    const headerHeigth = headerElement.getBoundingClientRect().height;

    const setStickyClass = () => {
      if (window.scrollY > headerHeigth + 20) {
        if (!headerElement.classList.contains(`header--sticky`)) {
          headerElement.classList.add(`header--sticky`);
          mainElement.style.paddingTop = `${headerHeigth}px`;

          console.log(`first`);

          setTimeout(() => {
            console.log(`2`);
            headerElement.classList.add(`header--show`);
          }, 100);
        }
      } else {
        if (headerElement.classList.contains(`header--sticky`)) {
          headerElement.classList.remove(`header--sticky`);
          headerElement.classList.remove(`header--show`);
          mainElement.style.paddingTop = `0`;
        }
      }
    };

    setStickyClass();
    document.addEventListener(`scroll`, setStickyClass);
  });
};

export default stickyHeader;
